import useWizardFormCtx from '../../../ctx-provider/useWizardFormCtx';
import RadioField from '../../../../../cmp/input/RadioField';
import RadioGroupField from '../../../../../cmp/input/RadioGroupField';
import StvJaNein from '../../../../../../consumer/form/dto/StvJaNein';
import useInputSubmitValidator, { generateValidatorId } from '../../../../../../form/input/useInputSubmitValidator';
import VorschadenValidator from './VorschadenValidator';
import FormBo from '../../FormBo';
import { useState } from 'react';
import StvJaNeinUnbekannt from '../../../../../../consumer/form/dto/StvJaNeinUnbekannt';
import GtmFormularfeldId from '../../../../../../gtm/types/GtmFormularfeldId';

export const exportVorschaden = (bo: FormBo) => bo.vorschaden;

const VALIDATOR_ID = generateValidatorId("Antrag-Vorschaden");

const Vorschaden = () => {
    const { wizardFormBo, fireWizardFormBo } = useWizardFormCtx();
    const [vorschaden, setVorschaden] = useState(wizardFormBo.antrag.vorschaden);

    const { validationState, fireFieldValidation } = useInputSubmitValidator(VALIDATOR_ID, new VorschadenValidator(vorschaden));

    const updateValidationState = (value?: StvJaNeinUnbekannt) => {
        fireFieldValidation(new VorschadenValidator(value as StvJaNeinUnbekannt));
    }

    // ****************************
    // events
    // ****************************  
    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        const valueEnum = StvJaNeinUnbekannt[value as StvJaNeinUnbekannt];
        setVorschaden(valueEnum);

        updateValidationState(valueEnum);

        wizardFormBo.antrag.vorschaden = valueEnum;
        fireWizardFormBo(wizardFormBo);
    }

    return (
        <RadioGroupField id='vorschaden' idGtm={GtmFormularfeldId.vorschaden} name="vorschaden" value={vorschaden}
            onChange={handleOnChange}
            error={validationState.error}
            helperText={validationState.message} >

            <RadioField value={StvJaNein.NEIN} label="nicht vorhanden" />
            <RadioField value={StvJaNein.JA} label="vorhanden" />
        </RadioGroupField>);

}

export default Vorschaden;